import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 4),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: (theme as any)?.palette?.navigation?.background || '#E3E4E8',
  },
  copyright: {
    color: '#FFFFFF',
    fontSize: '0.9rem',
  },
  link: {
    margin: theme.spacing(0, 2),
    color: '#FFFFFF',
    fontSize: '0.95rem',
    textDecoration: 'none',
  }
}));

/*
 Use href instead of internal routing 'to' so links work on the SignIn page
 (which is rendered outside the main AppRouter). */

const Footer: React.FC = () => {
  const classes = useStyles();
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <a href="https://allfunds.com/en/legal-advice/privacy-policy" className={classes.link} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <a href="https://allfunds.com/en/legal-advice/legal-notice" className={classes.link} target="_blank" rel="noopener noreferrer">Legal Notice</a>
        <a href="https://allfunds.com/en/legal-advice/cookies-policy" className={classes.link} target="_blank" rel="noopener noreferrer">Cookies Policy</a>
        <a href="https://allfunds.com/en/legal-advice/reporting-channel" className={classes.link} target="_blank" rel="noopener noreferrer">Reporting Channel</a>
      </div>

      <div className={classes.copyright} aria-hidden>
        {`Copyright © ${year} Allfunds Bank S.A.U., Allfunds is a registered trademark. All rights reserved.`}
      </div>
    </footer>
  );
};

export default Footer;
